import styled, { css } from 'styled-components'
import ripple from '../../styles/animations/ripple'

export interface DrawerProps {
  isMobile: boolean
  open: boolean
}

export const Container = styled.div<DrawerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  padding: 15px;
  margin-top: 5%;
  position: fixed;
  border-radius: 0px 15px 15px 0px;
  top: 0;
  left: 0;
  z-index: 110;
  box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.drawer};
  transition: left 0.1s cubic-bezier(0.82, 0.085, 0.395, 0.895);

  ${({ open, isMobile }) =>
    !open &&
    css`
      left: -300px;
    `}
  ${({ open, isMobile }) => {
    if (isMobile && open)
      return css`
        width: 100%;
        height: 100%;
        margin-top: 0px;
      `
  }}
`

export const ContentMiddle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 25px;
`

export const CloseButton = styled.div`
  margin-left: auto;
  ${ripple}
  cursor: pointer;
`

export const ContainerMobile = styled.div``

export const Content = styled.div<DrawerProps>`
  width: 100%;

  overflow-y: auto;
  height: 80vh;
  flex-wrap: nowrap;
  flex-direction: column;
  gap: 15px;

  ${({ isMobile, open }) =>
    isMobile &&
    open &&
    css`
      padding-top: 15px;
    `}
`
